import { useEffect } from "react";
import { Loading } from "@/component/Loading";
import { RuningInLink } from "@/constants";
import AIQA from "@/layout/AIQA";
import AIQAStore from "@/store/AIQA.store";
import summaryCommonStore from "@/store/summaryCommon.store";
import FILEDELETE from "@/assets/record/ic_file_delete.svg?react";
import IC_RETRY from "@/assets/record/ic_retry.svg?react";
import videoPlayerStore from "@/store/videoPlayer.store";
import { DetailErrorType } from "@/constants/record";
import MainLayout from "./MainLayout";
import PlayerFooter from "./PlayerFooter";
import RealVideo from "./PlayerFooter/RealVideo";
import "./index.less";
import { IS_PRIVATE } from "@/config";

interface IMainProps {
  hiddenSummary?: boolean;
}

const Main = ({ hiddenSummary }: IMainProps) => {
  const fullLoading = summaryCommonStore((state) => state.fullLoading);
  const errorStatus = summaryCommonStore((state) => state.errorStatus);
  const isAIQAMode = AIQAStore((store) => store.isAIQAMode);
  const WebAIQAMode = isAIQAMode && !RuningInLink && !IS_PRIVATE;

  const type = videoPlayerStore((store) => store.windowType);

  const handleRetry = () => {
    summaryCommonStore.getState().setErrorStatus(null);
    summaryCommonStore.getState().refreshSummaryKey();
  };

  useEffect(() => {
    return () => {
      videoPlayerStore.getState().reset();
    };
  }, []);

  return (
    <div className="w-full h-full flex flex-col">
      {type !== "foot" &&
        <RealVideo isOpen={true} />
      }
      {fullLoading ? (
        <div className="w-full flex-1 flex items-center justify-center">
          <Loading />
        </div>
      ) : errorStatus === DetailErrorType.deleted ? (
        <div className="flex-1 flex  flex-col items-center justify-center">
          <FILEDELETE className="w-15 h-22"></FILEDELETE>
          <span className="text-#1F25334D text-size-4 mt-3.5">
            源文件已删除
          </span>
        </div>
      ) : errorStatus === DetailErrorType.ERR_NETWORK ? (
        <div className="flex-1 flex  flex-col items-center justify-center">
          <IC_RETRY className="w-20 h-20" />
          <span className="mt-1 text-mx-quaternary text-3.5">加载超时</span>
          <div className="mt-4 b-1 border-solid b-#DBDEE4 w-22 h-8 rounded-1.5 flex justify-center items-center text-mx-secondary text-3.5 cursor-pointer" onClick={handleRetry}>
            重试
          </div>
        </div>
      ) : (
        <div className="w-full p-2 flex flex-1 overflow-hidden">
          <div className="w-full flex flex-col rounded-2 overflow-hidden">
            <div className="main-bg flex flex-1 relative overflow-hidden">
              <MainLayout hiddenSummary={hiddenSummary} />
            </div>
            {type === "foot" && <PlayerFooter />}
          </div>
          {WebAIQAMode && <AIQA />}
        </div>
      )}
    </div>
  );
};

export default Main;
